const state = {
  inpatientRecord: {},
  inpatientOrder: {}
}

const mutations = {
  addInpatientRecord (state, inpatientRecord) {
    state.inpatientRecord = { ...state.inpatientRecord, ...inpatientRecord }
  },
  clearInpatientRecord (state) {
    state.inpatientRecord = {}
  },

  setInpatientOrder (state, orders) {
    state.inpatientOrder = orders
  },

  clearInpatientOrder (state, orders) {
    state.inpatientOrder = {}
  }
}

const actions = {
  fetchInpatientRecord ({ commit }) {
    // 这里可以添加异步获取门诊患者列表逻辑
    // commit('setPatients', data)
  },
  addInpatientRecord ({ commit }, inpatientRecord) {
    commit('addInpatientRecord', inpatientRecord)
  },
  clearInpatientRecord ({ commit }) {
    commit('clearInpatientRecord')
  }
}

const getters = {
  inpatientRecord: state => state.inpatientRecord,
  inpatientOrder: state => state.inpatientOrder
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
